var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-SPRK_default_preset_name_custom_1);\n      }\n\n      .cls-22 {\n        fill: #091427;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-SPRK_default_preset_name_custom_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SPRK_default_preset_name_custom_1",
    "data-name": "SPRK_default_preset_name_custom \\u2013 1",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-1252.16 -255.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1274.536,258.306a.674.674,0,0,0-.474-.2h-10.506v-2.418a.669.669,0,0,0-1.067-.539l-8.019,5.916a.669.669,0,0,0,0,1.076l3.341,2.481a7.235,7.235,0,0,0,.22,4.2h-3.162a.708.708,0,0,0-.708.708v5.693a.707.707,0,0,0,.708.708h9.673v2.381a.708.708,0,0,0,1.129.57l8.018-5.916a.709.709,0,0,0,0-1.139l-2.55-1.893a7.2,7.2,0,0,0,.842-4.794h2.081a.669.669,0,0,0,.67-.67v-5.693A.675.675,0,0,0,1274.536,258.306Zm-9.694,14.533a6.477,6.477,0,1,1,6.477-6.477A6.484,6.484,0,0,1,1264.842,272.839Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1405.752,415.413a4.98,4.98,0,1,1-4.98-4.98A4.98,4.98,0,0,1,1405.752,415.413Zm-2.642-.95v-.077a1.422,1.422,0,0,0-1.334-1.409l0-.534h-.942l0,.53h-.386l0-.53h-.942l0,.53h-.687l0,.942h.467l.005,1.019,0,.942.005,1.132h-.467l0,.942h.687l0,.433h.942l0-.433h.386l0,.433h.942l0-.433h.036a1.46,1.46,0,0,0,1.46-1.467V416.4a1.468,1.468,0,0,0-.477-1.075A1.4,1.4,0,0,0,1403.11,414.464Zm-.756,2.02a.523.523,0,0,1-.523.525h-1.584l-.005-1.132h1.584a.529.529,0,0,1,.528.525v.082Zm-2.121-2.568h1.462a.474.474,0,0,1,.473.471v.077a.469.469,0,0,1-.469.471h-1.462l-.005-1.019Z",
    transform: "translate(-135.871 -149.09)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.7fbba8e766d3d0199eaea09e10d27c08.svg";
export { ForwardRef as ReactComponent };